import React, { useEffect, useState } from 'react';
import { Table, Button, Group, Text, Paper, Title, Modal, Stack, Divider, Anchor } from '@mantine/core';
import * as api from '../../api/index';
import { toast } from 'react-toastify';
import { baseUrl } from '../../api/index'; // Use baseUrl for static files

const EnquiryRequests = () => {
    const [enquiries, setEnquiries] = useState([]);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const fetchEnquiries = async () => {
        try {
            const { data } = await api.fetchEnquiries();
            setEnquiries(data.data);
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch enquiries");
        }
    };

    const handleDelete = async (id) => {
        try {
            await api.deleteEnquiry(id);
            toast.success("Enquiry deleted");
            fetchEnquiries();
        } catch (error) {
            console.error(error);
            toast.error("Failed to delete enquiry");
        }
    };

    useEffect(() => {
        fetchEnquiries();
    }, []);

    const rows = enquiries.map((enquiry) => (
        <tr key={enquiry._id}>
            <td>{enquiry.name}</td>
            <td>{enquiry.email}</td>
            <td>{enquiry.modelName || 'N/A'}</td>
            <td>
                {enquiry.fileUrl ? (
                    <Anchor href={enquiry.fileUrl.startsWith('http') ? enquiry.fileUrl : `${baseUrl}${enquiry.fileUrl.startsWith('/') ? enquiry.fileUrl.slice(1) : enquiry.fileUrl}`} target="_blank">
                        Download
                    </Anchor>
                ) : 'No File'}
            </td>
            <td>{new Date(enquiry.createdAt).toLocaleDateString()}</td>
            <td>
                <Group spacing="xs">
                    <Button variant="outline" size="xs" onClick={() => { setSelectedEnquiry(enquiry); setModalOpen(true); }}>
                        View
                    </Button>
                    <Button color="red" variant="outline" size="xs" onClick={() => handleDelete(enquiry._id)}>
                        Delete
                    </Button>
                </Group>
            </td>
        </tr>
    ));

    return (
        <Paper p="md" shadow="sm" radius="md">
            <Group position="apart" mb="md">
                <Title order={3}>Enquiry Requests</Title>
                <Button variant="light" onClick={fetchEnquiries}>Refresh</Button>
            </Group>

            <Table striped highlightOnHover>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Model Name</th>
                        <th>File</th>
                        <th>Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>{rows}</tbody>
            </Table>

            <Modal opened={modalOpen} onClose={() => setModalOpen(false)} title="Enquiry Details" size="lg">
                {selectedEnquiry && (
                    <Stack>
                        <Group position="apart">
                            <Text weight={700}>Name:</Text>
                            <Text>{selectedEnquiry.name}</Text>
                        </Group>
                        <Group position="apart">
                            <Text weight={700}>Email:</Text>
                            <Text>{selectedEnquiry.email}</Text>
                        </Group>
                        <Group position="apart">
                            <Text weight={700}>Phone:</Text>
                            <Text>{selectedEnquiry.phone || 'N/A'}</Text>
                        </Group>

                        <Divider my="sm" />

                        <Group position="apart">
                            <Text weight={700}>Model Name:</Text>
                            <Text>{selectedEnquiry.modelName}</Text>
                        </Group>
                        <Group position="apart">
                            <Text weight={700}>Material:</Text>
                            <Text>{selectedEnquiry.material}</Text>
                        </Group>
                        <Group position="apart">
                            <Text weight={700}>Color:</Text>
                            <Text>{selectedEnquiry.color}</Text>
                        </Group>
                        <Group position="apart">
                            <Text weight={700}>Quantity:</Text>
                            <Text>{selectedEnquiry.quantity}</Text>
                        </Group>

                        <Divider my="sm" />

                        <Text weight={700}>Instructions:</Text>
                        <Paper withBorder p="sm" bg="gray.0">
                            <Text>{selectedEnquiry.instructions || 'No special instructions.'}</Text>
                        </Paper>

                        {selectedEnquiry.fileUrl && (
                            <Button component="a" href={selectedEnquiry.fileUrl.startsWith('http') ? selectedEnquiry.fileUrl : `${baseUrl}${selectedEnquiry.fileUrl.startsWith('/') ? selectedEnquiry.fileUrl.slice(1) : selectedEnquiry.fileUrl}`} target="_blank" leftIcon={<i className="fas fa-download"></i>} variant="outline">
                                Download 3D Model File
                             </Button>
                        )}
                    </Stack>
                )}
            </Modal>
        </Paper>
    );
};

export default EnquiryRequests;
